/**
 * Get the index of the item in the animation offset array
 */
export var getAnimationOffsetIndex = function getAnimationOffsetIndex(columnCount, itemNumber, maxItemsPerColumn) {
  return itemNumber - columnCount * maxItemsPerColumn;
};